import React, { FC, useState } from 'react'
import { Callback, Region } from 'Pages/landings/common/types'
import { InputComponent } from 'Pages/landings/common/components/Input/RkoInput'
import { ModalTitle, ModalBody } from './styled'

interface ComponentProps {
	regionAutoDetection?: Region
	regions: Region[]
	setRegion?: (reg: Region) => void
	setIsShowModal: Callback
}

export const RegionModalComponent: FC<ComponentProps> = ({
	regions,
	regionAutoDetection,
	setRegion,
	setIsShowModal,
}) => {
	const [search, setSearch] = useState('')
	const [searchedRegions, setSearchedRegions] = useState(null)
	const [localRegion, setLocalRegion] = useState(null)

	const className = {
		region: 'modal-landing-region',
		input: 'modal-landing-region_input--search',
		list: 'modal-landing-region_list',
		item: 'modal-landing-region_list_item',
		itemActive: 'modal-landing-region_list_item-active',
	}

	const searchRegions = (value) => {
		setSearch(value)
		if (!value) {
			setSearchedRegions(null)
		} else {
			const searchingRegions = regions.filter((region): boolean => {
				const { name } = region
				return name.toLocaleLowerCase().search(value.toLocaleLowerCase()) !== -1
			})
			setSearchedRegions(searchingRegions)
		}
	}

	const selectRegion = (region: Region) => {
		if (setRegion) setRegion(region)
		setLocalRegion(region)
		setIsShowModal()
	}

	const renderItem = (region: Region) => {
		const { name, id } = region
		const currentId = localRegion?.id || regionAutoDetection?.id
		return (
			<div
				key={id}
				className={id === currentId ? className.itemActive : className.item}
				onClick={() => selectRegion(region)}
			>
				{name}
			</div>
		)
	}

	const listRegions = searchedRegions ?? regions

	return (
		<>
			<ModalTitle>Выбор региона</ModalTitle>
			<ModalBody>
				<div className={className.input}>
					<InputComponent
						type="text"
						name="search"
						placeholder="поиск"
						onChange={(e) => searchRegions(e.currentTarget.value)}
						value={search}
					/>
				</div>
				<div className={className.list}>
					{Boolean(listRegions?.length) && listRegions.map((region) => renderItem(region))}
				</div>
			</ModalBody>
		</>
	)
}
